import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'
import * as Sentry from '@sentry/browser'

// TODO: 往後御霖可能會關掉就可以撤掉了
// Swagger: https://alarm-dev.kingnetsmart.com.tw/swagger/index.html
const instance = axios.create({
  baseURL: `${process.env.VUE_APP_HOUSEKEEPER_WEB_URL}/api/v1/Alarm`
})
instance.defaults.paramsSerializer = (params) => {
  return qs.stringify(params, { arrayFormat: 'repeat' })
}

const sourceInstance = axios.create({
  baseURL: 'https://alarm-dev.kingnetsmart.com.tw/api/'
})
sourceInstance.interceptors.request.use(
  (reqConfig) => {
    const tempReqConfig = { ...reqConfig }
    const xCorrelationId = Vue.prototype.$getGuid()
    tempReqConfig.headers = {
      'x-comid': JSON.parse(localStorage.getItem('loginUserInfo')).ComId,
      'api-version': 1.0,
      AuthenticationScheme: 'ApiKeyAuthenticationHandler',
      authorization: 'Bearer 41ECDC17-4E01-4E92-91FB-92C9B6E0A9BE',
      'X-Correlation-Id': xCorrelationId
    }
    Sentry.setTag('X-Correlation-Id', xCorrelationId)
    return tempReqConfig
  },
  (err) => {
    return Promise.reject(err)
  }
)
const INT32_MAX_VALUE = 2147483647
export const apiBaAlertSource = {
  mockLog: (idArr, isNormal) => sourceInstance.post('/Test/MockLog', {
    TagIds: idArr,
    Status: isNormal ? 'Normal' : 'Abnormal'
  }),
  getEventById: (id) => sourceInstance.get(`/Event/${id}`),
  getTags: () => sourceInstance.get('/Tag/', {
    params: {
      'Pagination.Count': INT32_MAX_VALUE // 後端提供此欄位規格為 int 32
    }
  })
}
